import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as fromTracking from './tracking.reducer'

export const selectTrackingState = createFeatureSelector<fromTracking.TrackingState>(
  fromTracking.TRACKING_KEY,
)

export const selectTrackingData = createSelector(selectTrackingState, (state) => state.trackingData)

export const selectTrackingMyViewsData = createSelector(
  selectTrackingState,
  (state) => state.trackingMyViewsData,
)

export const selectTrackingTeamViewsData = createSelector(
  selectTrackingState,
  (state) => state.trackingTeamViewsData,
)

export const selectTrackingClientViewsData = createSelector(
  selectTrackingState,
  (state) => state.trackingClientViewsData,
)

export const selectTrackingSelectors = createSelector(
  selectTrackingState,
  (state) => state.selectors,
)

export const selectMyViewTrackingSelectors = createSelector(
  selectTrackingState,
  (state) => state.myViewSelectors,
)

export const selectTeamViewTrackingSelectors = createSelector(
  selectTrackingState,
  (state) => state.teamViewSelectors,
)

export const selectInceptionTimeInterval = createSelector(
  selectTrackingState,
  (state) => state.inceptionTimeInterval,
)

export const selectIsLoading = createSelector(
  selectTrackingState,
  (state) => state.isLoading || state.isPreferenceLoading,
)

export const selectIsDetailsLoading = createSelector(
  selectTrackingState,
  (state) => state.isDetailsLoading,
)

export const selectTrackingUserPreferences = createSelector(
  selectTrackingState,
  (state) => state.trackingUserPreferences,
)
